import { ProviderTypes } from "lib/generated/integration-api/models/ProviderTypes";
import UIcon, { CustomIconKey } from "lib/icons/untitled_ui/UIcon";
import { hubspotOrange, salesforceBlue } from "lib/themes/colors";
import {
  PROVIDER_METADATA,
  PROVIDER_OPPORTUNITY_METADATA,
  ProviderMetadata,
  ProviderOpportunityMetadata,
} from "./providerMetadata";

export const providerIconMap: Record<ProviderTypes, CustomIconKey> = {
  SALESFORCE: "salesforce",
  HUBSPOT: "hubspot",
};

export function getProviderIconColor(providerType: ProviderTypes) {
  return providerType === ProviderTypes.Hubspot ? "#ff7a59" : "#00A1E0";
}

export function getIntegrationIcon(providerType: ProviderTypes, size: number = 16): JSX.Element {
  switch (providerType) {
    case ProviderTypes.Hubspot:
      return <UIcon icon="hubspot" color={hubspotOrange} size={size} />;
    case ProviderTypes.Salesforce:
      return <UIcon icon="salesforce" color={salesforceBlue} size={size} />;
    default:
      throw new Error(`Unsupported integration ${providerType}.`);
  }
}

export function getProviderMetadata(
  providerType: ProviderTypes,
  hasOpportunityCrm: boolean,
): ProviderMetadata | ProviderOpportunityMetadata {
  return hasOpportunityCrm
    ? PROVIDER_OPPORTUNITY_METADATA[providerType]
    : PROVIDER_METADATA[providerType];
}

export const friendlyProviderName: Record<ProviderTypes, string> = {
  [ProviderTypes.Hubspot]: "HubSpot",
  [ProviderTypes.Salesforce]: "Salesforce",
};

export function getNoticeHeaderCopy(providerType: ProviderTypes, entityName: string) {
  const headerCopy = PROVIDER_METADATA[providerType].createNoticeModal[entityName];
  if (!headerCopy) throw `Unsupported entity name ${entityName} for provider ${providerType}`;
  else return headerCopy;
}

export function getOpportunityHeaderCopy(providerType: ProviderTypes, entityName: string) {
  const headerCopy = PROVIDER_OPPORTUNITY_METADATA[providerType].createOpportunityModal[entityName];
  if (!headerCopy) throw `Unsupported entity name ${entityName} for provider ${providerType}`;
  else return headerCopy;
}
